import { render, staticRenderFns } from "./ANCESTRY_COMPOSITION.vue?vue&type=template&id=83487bc6&"
import script from "./ANCESTRY_COMPOSITION.vue?vue&type=script&lang=js&"
export * from "./ANCESTRY_COMPOSITION.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports